export default class AutoResetEvent {
  constructor() {
    this.isSignaled = false;
    this.waiters = [];
  }

  async waitOne() {
    if (this.isSignaled) {
      this.isSignaled = false; // Auto-reset behavior
      return;
    }
    return new Promise((resolve) => this.waiters.push(resolve));
  }

  set() {
    if (this.waiters.length > 0) {
      const waiter = this.waiters.shift(); // Resolve only one
      waiter();
    } else {
      this.isSignaled = true; // Mark as signaled
    }
  }

  reset() {
    this.isSignaled = false;
    this.waiters = [];
  }
}
